import React from "react";
import classes from "./LetterIcon.css";
const LetterIcon = props => {
  return (
    <div
      className={classes.LetterIcon}
      style={{
        backgroundColor: props.color,
        cursor: props.clicked ? "pointer" : "default"
      }}
      onClick={props.clicked}
    >
      <span> {props.letter} </span>
    </div>
  );
};

export default LetterIcon;
